import { Component, OnInit } from '@angular/core';
import { RaffleListFilter } from '@core/models/raffle-list-filter.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { RaffleCategoryMetadata, RaffleSimple } from '@core/models/raffle.model';
import { HttpClient } from '@angular/common/http';
import { API_LIST } from '@core/services/web-api/api-list';
import { RootPathCheckerService } from '@project/core/services/root-path-checker/root-path-checker.service';
import { PathType, PathTypeToken } from '@core/services/root-path-checker/root-path-checker.models';

@Component({
  selector: 'app-category-raffles',
  templateUrl: './category-raffles.component.html',
  styleUrls: ['./category-raffles.component.scss']
})
export class CategoryRafflesComponent implements OnInit {
  public hasError404 = false;
  public defaultFilter = RaffleListFilter.Date;
  public slug: string;
  public category: RaffleCategoryMetadata;
  public isLoading = true;
  public competitions: RaffleSimple[];
  public selectedFilter: RaffleListFilter = this.defaultFilter;
  public filters = [
    {
      value: RaffleListFilter.Popularity,
      name: 'Sort by popularity',
    }, {
      value: RaffleListFilter.Date,
      name: 'Sort by latest',
    }, {
      value: RaffleListFilter.Price,
      name: 'Sort by price: low to high',
    }, {
      value: RaffleListFilter.PriceDesc,
      name: 'Sort by price: high to low',
    }
  ];
  public limitPerPage = 48;
  public page = 0;
  public resultOffset = 0;
  public numberFirstResult = 0;
  public numberLastResult = 0;
  public numberAllResults = 0;
  public maxPages = 0;


  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private httpClient: HttpClient,
    private rootPathChecker: RootPathCheckerService,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.hasError404 = false;
      this.slug = this.activatedRoute.snapshot.data['slug'] ? this.activatedRoute.snapshot.data['slug'] : this.activatedRoute.snapshot.params['slug'];
      this.initPageData(this.activatedRoute.snapshot.params['page']);
      this.initOrderBy(this.activatedRoute.snapshot.queryParams['orderBy']);

      this.rootPathChecker.checkBySlug(this.slug).subscribe((token: PathTypeToken) => {
        switch (token.pathType) {
          case PathType.category:
            this.category = token.categoryData;
            this.initCompetitions();
            break;

          case PathType.result:
            this.router.navigate(['/draw-result', token.slug]);
            break;

          case PathType.winner:
            this.router.navigate(['/winner', token.slug]);
            break;

          default:
            this.hasError404 = true;
            break;
        }
      });
    });
  }

  initPageData(inputPage) {
    this.page = Number(inputPage) - 1;

    if (this.page < 0 || isNaN(this.page)) {
      this.page = 0;
    }
  }

  initOrderBy(inputOrderBy) {
    this.filters.forEach((data) => {
      if (inputOrderBy === data.value || (!inputOrderBy && data.value === this.defaultFilter)) {
        this.selectedFilter = data.value;
      }
    });
  }

  initCompetitions() {
    this.isLoading = true;
    this.competitions = [];

    let categories = this.category.showAllRaffles ? [] : [this.slug], sortby: string = RaffleListFilter.ValueDesc;
    this.resultOffset = this.page * this.limitPerPage;

    if (this.category.showSorting) {
      sortby = this.selectedFilter;
    } else if (this.slug === 'current-competitions' || this.slug === 'cash-competitions' || this.slug === 'current-tech-competitions' || this.slug === 'competitions') {
      sortby = RaffleListFilter.Date;
    }

    if (this.category.sortBy) {
      sortby = this.category.sortBy;
    }

    this.httpClient.get(
      API_LIST.getRaffleDraws('GBP', categories, this.limitPerPage, false, true, this.resultOffset, sortby, this.category.filter),
      { observe: 'response' }
    ).subscribe((response) => {

      if (this.slug === 'competitions') {
        let competitions: RaffleSimple[] = [];

        this.httpClient.get(
          API_LIST.getRaffleDraws('GBP', ['biggest-competitions'], this.limitPerPage, false, true, this.resultOffset, 'value-desc', this.category.filter),
          { observe: 'response' }
        ).subscribe((res) => {
          competitions = <RaffleSimple[]>res.body;
          const allCompetitions = <RaffleSimple[]>response.body;
          this.competitions = competitions.concat(allCompetitions.filter(item => !competitions.find(el => el.id === item.id)));
          this.isLoading = false;
        });

      } else {
        this.competitions = <RaffleSimple[]>response.body;
        this.isLoading = false;
      }

      this.numberAllResults = Number(response.headers.get('X-Count'));
      this.numberFirstResult = this.resultOffset + 1;
      this.numberLastResult = this.numberFirstResult + this.competitions.length - 1;
      this.maxPages = Math.ceil(this.numberAllResults / this.limitPerPage);

    });

  }

  handleFilter(value: string) {
    this.router.navigate([window.location.pathname], {
      queryParams: {
        orderBy: value !== this.defaultFilter ? value : null,
      },
      queryParamsHandling: 'merge',
    }).then(() => {
      this.initOrderBy(this.activatedRoute.snapshot.queryParams['orderBy']);
      this.initCompetitions();
    });
  }

}
